import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import bemify from 'bemify-js';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import Button from 'app/common/components/Button';
import Link from 'app/common/components/Link';
import TaskStatusIcon from 'app/history/components/TaskStatusIcon';
import {
  GLOBAL_FAILURE_LINKS,
  MASS_DELETE_STATUSES,
  MASS_REPLAY_ERRORS_FREE_PLAN,
  MASS_REPLAY_STATUSES,
  PAYMENT_ISSUE,
  SEE_DETAILS_TEXT,
  SEE_DETAILS_URLS,
} from 'app/history/utils/constants';
import 'app/viewport/components/TaskReplayCompleteMessage.scss';

const bem = bemify('task-replay-complete-message');

const renderTaskSummaryMessages = ({
  channelId,
  statusCounts: counts,
  unreplayableErrors,
  onSeeDetails,
  isFreeAccount,
  action,
}) => {
  return _.map(counts, (count, status) => {
    const isReplay = action === 'replay';
    const messages = isReplay
      ? isFreeAccount
        ? MASS_REPLAY_ERRORS_FREE_PLAN
        : MASS_REPLAY_STATUSES
      : MASS_DELETE_STATUSES;
    const msgFn = messages[status];

    if (!msgFn) {
      return null; // success
    }

    const isChannelError = _.includes(Object.keys(unreplayableErrors), status);
    const statusParamKey = isChannelError ? 'channel_error' : 'status';
    const seeDetailsUrl =
      SEE_DETAILS_URLS[status] ||
      `/app/history?channel=${channelId}&${statusParamKey}=${status}`;
    const seeDetailsText = SEE_DETAILS_TEXT[status] || 'See Details';

    const isMassActionSuccessful = status === 'success' || status === 'deleted';
    const iconStatus = isMassActionSuccessful ? 'success' : 'deleted';
    const iconKind = isMassActionSuccessful ? 'small' : 'small error';

    return (
      <div className={bem('__message-wrapper')} key={status}>
        <div className={bem('__message')}>
          <div className={bem('__icon')}>
            <TaskStatusIcon kind={iconKind} status={iconStatus} />
          </div>
          <div className={bem('__text')}>
            <div>{msgFn(count)}</div>
            {status !== 'deleted' && (
              <Link href={seeDetailsUrl} onClick={onSeeDetails}>
                {seeDetailsText}
              </Link>
            )}
          </div>
        </div>
      </div>
    );
  });
};

const renderGlobalFailureMessages = ({ globalFailureType, globalFailures }) => {
  const hasPaymentIssues = globalFailureType === PAYMENT_ISSUE;
  const globalFailureLink = GLOBAL_FAILURE_LINKS[globalFailureType];

  return [
    <div className={bem('__message-wrapper')} key="global-failure">
      <div className={bem('__message')}>
        <div className={bem('__icon')}>
          <TaskStatusIcon kind="small error" status="deleted" />
        </div>
        <div className={bem('__text')}>
          <div>{globalFailures}</div>
          <div className={bem('__link')}>
            {hasPaymentIssues ? (
              <Button
                className={bem('__button')}
                href={globalFailureLink.href}
                kind="primary large"
                tag="a"
              >
                {globalFailureLink.text}
              </Button>
            ) : (
              <Link href={globalFailureLink.href} kind="primary large">
                {globalFailureLink.text}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>,
  ];
};

const TaskReplayCompleteMessage = createReactClass({
  displayName: 'TaskReplayCompleteMessage',

  propTypes: {
    globalFailures: PropTypes.arrayOf(PropTypes.string),
    globalFailureType: PropTypes.string,
    channelId: PropTypes.string.isRequired,
    statusCounts: PropTypes.object.isRequired,
    unreplayableErrors: PropTypes.object.isRequired,
    onSeeDetails: PropTypes.func.isRequired,
    isFreeAccount: PropTypes.bool.isRequired,
    action: PropTypes.string.isRequired,
  },

  getDefaultProps() {
    return {
      isMassActionsDisabled: false,
    };
  },

  render() {
    const { props } = this;
    const hasGlobalFailures = !_.isEmpty(props.globalFailures);

    const messages = hasGlobalFailures
      ? renderGlobalFailureMessages(props)
      : renderTaskSummaryMessages(props);

    if (_.isEmpty(_.compact(messages))) {
      return null;
    }

    return <div className={bem()}>{messages}</div>;
  },
});

export default TaskReplayCompleteMessage;
